<template>
  <div style="
            height: 100%;display: flex;display: -webkit-flex; flex-direction:column;align-items:center">
    <div style="width: 12px;
    height: 12px;    background-color: #E4E7ED;
    border-radius: 50%;
"></div>
    <div style="height: 100%;
    background-color: #E4E7ED;width:2px;"></div>
  </div>
</template>
<script>
    import Vue from "vue";
    export default {
      name: 'MyStepLine',
        data(){
            return {};
        }
    }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/MyStepLine.vue